import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { transform } from 'lodash';
import { take } from 'rxjs';
import { PdfGeneratorService } from 'src/app/shared/services/pdf-generator.service';
import { UserDataService } from 'src/app/shared/services/user-data.service';

@Component({
  selector: 'app-dashboard-client',
  templateUrl: './dashboard-client.component.html',
  styleUrls: ['./dashboard-client.component.scss'],
})
export class DashboardClientComponent implements OnInit {
  appointmentDetails: any;
  eyeIcon = '../../../../assets/images/eye.png';
  downloadIcon = '../../../../assets/images/download.png';
  printIcon = '../../../../assets/images/printer (2).png';
  pdfContent: any;
  client: any;
  asiyaImgPath = '../../../../assets/images/asiya_ali.jpeg';
  disable = true;
  constructor(
    private firestore: AngularFirestore,
    public userDetails: UserDataService,
    public pdfGenerator: PdfGeneratorService
  ) {}

  ngOnInit(): void {
    this.pdfGenerator.getData(this.userDetails.userUID).then((data: any) => {
      this.pdfContent = data;
    });
    this.getClientProfile();
    this.getAptDetails();
  }

  getAptDetails() {
    this.firestore
      .collection('appointmentDetails')
      .doc(this.userDetails.userUID)
      .get()
      .pipe(takeUntil(1))
      .subscribe((data: any) => {
        if (data.data()) {
          this.appointmentDetails = data
            .data()
            .appointDetails.filter(
              (x: any) => x.appotStatus === 'Scheduled'
            )[0];
        }
      });
  }

  getClientProfile() {
    this.firestore
      .collection('clientProfile')
      .doc(this.userDetails.userUID)
      .get()
      .pipe(take(1))
      .subscribe((data: any) => {
        this.client = data.data();
        this.transformDate();
      });
  }

  transformDate() {
    this.client.packageEndDate = new Date(
      this.client.packageEndDate.seconds * 1000
    );
    this.client.packageStartDate = new Date(
      this.client.packageStartDate.seconds * 1000
    );
  }

  scheduleApt() {
    window.open(
      'https://6000-firebase-studio-1756609053183.cluster-64pjnskmlbaxowh5lzq6i7v4ra.cloudworkstations.dev/',
      '_blank'
    );
  }
}
function takeUntil(
  arg0: number
): import('rxjs').OperatorFunction<
  import('firebase/compat').default.firestore.DocumentSnapshot<unknown>,
  unknown
> {
  throw new Error('Function not implemented.');
}
